export const labels = {
	left: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment.Left",
		default: "Left",
	},
	center: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment.Center",
		default: "Center",
	},
	right: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment.Right",
		default: "Right",
	},
	top: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment.Top",
		default: "Top",
	},
	middle: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment.Middle",
		default: "Middle",
	},
	bottom: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment.Bottom",
		default: "Bottom",
	},
};
